module.exports = __webpack_public_path__ + "static/img/concierge_banner.87eca85.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/preview/home/concierge_banner.png
// module id = +7L2
// module chunks = 1